import {
    ConnectionProvider,
    IntegrationConnection,
} from "../../common/types/integrationConnection";
import { ExtendedButtonProps } from "../general/Button/Button";
import { FixPayPalConnection } from "../paypal/FixPayPalConnection";

interface Props extends Omit<ExtendedButtonProps, "onClick"> {
    integrationConnection: IntegrationConnection;
    children: React.ReactNode;
}

export const FixIntegrationConnection: React.FC<Props> = ({
    integrationConnection,
    children,
    ...btnProps
}) => {
    if (integrationConnection.provider === ConnectionProvider.PAYPAL) {
        return (
            <FixPayPalConnection
                connection={integrationConnection}
                {...btnProps}
            >
                {children}
            </FixPayPalConnection>
        );
    }
};
